/*
 * The modification-only selectors of the basket slice. The creation ones stay in @wecasa/customer:
 * only the selectors read exclusively by a modification funnel live here.
 */
import { createSelector } from 'reselect';

import { extractAppointmentFromBooking } from '../utils/basket';
import type { ModifiedBookingRootState } from './types';

export const getBookingToModify = (state: ModifiedBookingRootState) => state.basket.bookingToModify;

export const getOrderChangeRequest = (state: ModifiedBookingRootState) => state.basket.orderChangeRequest;

export const getPotentialUpdate = (state: ModifiedBookingRootState) => state.basket.potentialUpdate;

export const getPreviousBooking = (state: ModifiedBookingRootState) => state.basket.bookingToModify.current;

export const getUpdateAllOccurrences = (state: ModifiedBookingRootState) => state.basket.updateAllOccurrences;

export const getModifiedBooking = createSelector([getBookingToModify], (bookingToModify) =>
  'public_id' in bookingToModify.current ? bookingToModify.current : undefined,
);

export const getPreviousBookingAppointment = createSelector([getPreviousBooking], (booking) =>
  'appointment' in booking && booking.appointment ? extractAppointmentFromBooking(booking) : null,
);

export const getPreviousBookingOrNull = createSelector([getPreviousBooking], (booking) =>
  'type' in booking ? booking : null,
);
